import api from './api';

export interface ProductRelation {
  _id: string;
  productId: string;
  relatedProductId: string;
  createdAt: string;
  updatedAt: string;
}

export interface ProductWithRelations {
  _id: string;
  name: string;
  mainImage?: string;
  relatedCount: number;
}

// جلب جميع المنتجات مع عدد العلاقات
export const getAllProductsWithRelations = async (
  search?: string,
  page: number = 1,
  limit: number = 50
) => {
  const params = new URLSearchParams();
  if (search) params.append('search', search);
  params.append('page', page.toString());
  params.append('limit', limit.toString());

  const response = await api.get(`/product-relations?${params.toString()}`);
  return response.data;
};

// جلب المنتجات المرتبطة بمنتج معين
export const getRelatedProducts = async (productId: string) => {
  const response = await api.get(`/product-relations/${productId}`);
  return response.data.data;
};

// تحديث العلاقات
export const updateProductRelations = async (
  productId: string,
  relatedProductIds: string[]
) => {
  const response = await api.put(`/product-relations/${productId}`, {
    relatedProductIds
  });
  return response.data;
};

// حذف علاقة
export const deleteProductRelation = async (
  productId: string,
  relatedProductId: string
) => {
  const response = await api.delete(
    `/product-relations/${productId}/${relatedProductId}`
  );
  return response.data;
};

// تحميل قالب Excel للمنتجات المرتبطة
export const downloadProductRelationsTemplate = async () => {
  const response = await api.get('/product-relations/download-template', {
    responseType: 'blob'
  });
  
  // إنشاء رابط للتحميل
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'product-relations-template.xlsx');
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// استيراد المنتجات المرتبطة من Excel
export const importProductRelations = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post('/product-relations/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  
  return response.data;
};
